import { tifiKe } from './ke';
import { champloan } from './es';
export const getNextDay = () => {
  const t = new Date(Date.now() + 24 * 60 * 60 * 1000);
  const y = t.getFullYear();

  let d = t.getDate();
  d = d >= 10 ? d : ('0' + d);
  let m = t.getMonth() + 1;
  m = m >= 10 ? m : ('0' + m);

  return y + '' + m + '' + d;
}

export const RskashTermsMap = {
  'Application ID':	'Customer Application ID Generated by the Fintech system for Reference. It can also be replaced by the Loan ID',
  'Sanction Date': 'Date of the issue of sanction letter',
  'Borrower':	'Name of the Borrower',
  'Borrower PAN':	'Unique PAN number of the borrower',
  'Lender': 'X10 Financial Services Limited',
  'Service Provider / App':	'RsKash',
  'Propose of Loan':	'Personal Loan',
  'Principal Loan Amount':	'Loan Amount',
  'Rate of Interest': 'Annual Rate of Interest in Percentage',
  'Processing Fees charged by the Service Provider': 'Amount of Processing fees payable on this loan ( Amount + GST Amount)',
  'Other fees [Charged by]': 'Any other fees if charged ( Amount + GST Amount',
  'Amount to be Disbursed': 'Net Amount that will be disbursed to the Customer',
  'Due Date':	'Date when Loan is Due for Repayment',
  'Repayment Amount': 'Amount to be paid on Due Date',
  'Penalty Interest': 'Penalty Interest Applicable in case of Delay',
  'Pre-Payment Penalty':	'None',
  // 'e mandate dishonour charges':	'Charges applicable if E mandate is Dishonoured',
  'Validity of Sanction': getNextDay(), // 'Sanction Date + 1 day.( or as per policy)',
}

export default {
  'tifi-ke': tifiKe,
  champloan,
}